import type { FrontModule } from "@nabble/sdk";
import { lazy } from "react";

const InitiativesPage = lazy(() => import("./pages/InitiativesPage/InitiativesPage"));
const InitiativePage = lazy(() => import("./pages/InitiativePage/InitiativePage"));

export const providerProspectsModule: FrontModule = {
  id: "provider-prospects",
  version: "0.1.0",
  permission: "provider-prospects.read",
  label: "Provider Prospects",
  icon: "briefcase",
  description:
    "Compare providers and their plans for each purchase, and record which one you chose.",
  routes: [
    { path: "/provider-prospects", Component: InitiativesPage },
    { path: "/provider-prospects/:initiativeId", Component: InitiativePage },
  ],
  menu: [
    {
      id: "provider-prospects.initiatives",
      label: "Initiatives",
      icon: "briefcase",
      path: "/provider-prospects",
      permission: "provider-prospects.read",
      description: "Purchases and the providers being compared",
    },
  ],
};

export default providerProspectsModule;
